import { combineReducers } from "redux";
import { alertsState } from "./alertsReducer";

export const alertsReducer = combineReducers({
    alertsState: alertsState
});
